module.exports = __webpack_public_path__ + "img/public/SiteIcons/rulesIcon.svg?6a671a38";